import React from 'react'
import DeclarerCourier from './DeclarerCourier.js';

const CourierContainer = () => {
    return (
        <section style={{ backgroundImage: `url(./img/backgrounds/suivi.jpg)`, top: 'center', }} id="hero" className="in-containerlog d-flex align-items-center justify-content-center">
            <div className="container login-inner" data-aos="fade-up">
                <div className="row justify-center" data-aos="zoom-in" data-aos-delay="250">
                    <div className="col-12 login-container-mobile">
                        <DeclarerCourier />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CourierContainer